"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Autocomplete2 = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _TextField2 = _interopRequireDefault(require("@material-ui/core/TextField"));

var _ArrowDropDownRounded2 = _interopRequireDefault(require("@material-ui/icons/ArrowDropDownRounded"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _styles = require("@material-ui/core/styles");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("../../propTypes");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    tab: {
      paddingLeft: "1rem",
      paddingRight: "1rem",
      paddingTop: "0.25rem",
      paddingBottom: "0.25rem",
      borderTopRightRadius: "0.25rem",
      borderTopLeftRadius: "0.25rem",
      fontWeight: 500,
      cursor: "pointer"
    },
    text: {
      fontSize: "0.75rem",
      color: "rgba(107, 114, 128, 1)"
    },
    nothingLinkRecord: {
      fontSize: "0.875rem",
      color: "rgba(156, 163, 175, 1)"
    }
  };
});

var Lookup = function Lookup(_ref) {
  var getData = _ref.getData,
      setOptions = _ref.setOptions,
      options = _ref.options;
  var classes = useStyles();

  var _useState = (0, _react.useState)("configuration"),
      _useState2 = _slicedToArray(_useState, 2),
      tab = _useState2[0],
      setTab = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      fields = _useState4[0],
      setFields = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      relationFields = _useState6[0],
      setRelationFields = _useState6[1];

  var getFields = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getData("field");

            case 3:
              result = _context.sent;
              setFields(result.filter(function (item) {
                return item.type === "linkToRecord";
              }));
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function getFields() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    getFields();
  }, []);

  var handleChangeFrom = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e, value) {
      var foreignTableId, result, blacklist;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              foreignTableId = value.options.foreignTableId;
              setOptions(_objectSpread(_objectSpread({}, options), {}, {
                relationTableId: foreignTableId,
                localFieldId: value.id
              }));
              _context2.next = 4;
              return getData("field", {
                tableId: foreignTableId
              });

            case 4:
              _context2.next = 6;
              return _context2.sent;

            case 6:
              result = _context2.sent;
              blacklist = ["linkToRecord", "lookup"];
              setRelationFields(result.filter(function (item) {
                return !blacklist.includes(item.type);
              }));

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChangeFrom(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleChangeRelation = function handleChangeRelation(e, value) {
    setOptions(_objectSpread(_objectSpread({}, options), {}, {
      relationFieldId: value.id
    }));
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingRight: "1rem",
      fontSize: "0.875rem",
      marginTop: "0.25rem",
      color: "rgba(156, 163, 175, 1)"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, "Lookup a field on linked records."), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: "0.75rem",
      display: "flex"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    style: {
      backgroundColor: tab === "configuration" ? "rgba(0,0,0,0.05)" : "unset",
      color: tab === "configuration" ? "rgba(75, 85, 99, 1)" : "rgba(156, 163, 175, 1)"
    },
    className: classes.tab,
    onClick: function onClick() {
      return setTab("configuration");
    }
  }, "Configuration"))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: "rgba(0,0,0,0.05)",
      fontSize: "0.875rem"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingTop: "0.5rem",
      paddingBottom: "0.5rem",
      paddingRight: "1rem",
      paddingLeft: "1rem"
    }
  }, tab === "configuration" ? fields !== null && fields !== void 0 && fields.length ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.text
  }, "Field on this table that links to the records you want to look up"), /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
    style: {
      outline: "none",
      marginTop: "0.5rem",
      marginBottom: "0.5rem",
      backgroundColor: "white"
    },
    fullWidth: true,
    size: "small",
    getOptionLabel: function getOptionLabel(option) {
      return option.field;
    },
    options: fields,
    onChange: handleChangeFrom,
    popupIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], null),
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({}, params, {
        placeholder: "Choose a field in this table",
        fullWidth: true,
        variant: "outlined",
        inputProps: _objectSpread(_objectSpread({}, params.inputProps), {}, {
          autoComplete: "new-password"
        }),
        size: "small"
      }));
    }
  }), (options === null || options === void 0 ? void 0 : options.localFieldId) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.text
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: "rgba(31, 41, 55, 1)",
      fontWeight: 500
    }
  }), " table field that you'd like to look up"), /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
    style: {
      outline: "none",
      marginTop: "0.5rem",
      marginBottom: "0.5rem",
      backgroundColor: "white"
    },
    fullWidth: true,
    size: "small",
    getOptionLabel: function getOptionLabel(option) {
      return option.name;
    },
    options: relationFields,
    onChange: handleChangeRelation,
    popupIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], null),
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({}, params, {
        placeholder: "Choose a field",
        fullWidth: true,
        variant: "outlined",
        inputProps: _objectSpread(_objectSpread({}, params.inputProps), {}, {
          autoComplete: "new-password"
        }),
        size: "small"
      }));
    }
  }))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.nothingLinkRecord
  }, "You need a link field to create a lookup. Create the link field before configuring this lookup field.") : /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.nothingLinkRecord
  }, "Your field is not fully configured. You need to have a valid field configuration in the formula tab before adding formatting options."))));
};

Lookup.propTypes = _propTypes.OptionProps;
var _default = Lookup;
exports["default"] = _default;